export default "__VITE_ASSET__5a13a5e3__"